import React from "react";
import ReactDOM from "react-dom";
import AddFundsAutoGrow from "../components/add_funds/add_funds_auto_grow";
import styled from "styled-components/macro";
import { inEmbedMode } from "../odc-ui";

const Explanation = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 50px;
`;

const ExternalPurchaseAutoGrow = () => {
  const renderPreamble = () =>
    inEmbedMode() ? null : (
      <Explanation>
        <div>
          Thank you for choosing Heathcoin® Auto Grow. To complete your purchase
          and set up your subscription, please fill out the form below.
        </div>
      </Explanation>
    );

  return (
    <div>
      <AddFundsAutoGrow
        theme="paige"
        external={true}
        renderPreamble={renderPreamble}
      />
    </div>
  );
};

document.addEventListener("DOMContentLoaded", () => {
  const mountPoint = document.getElementById(
    "external-purchase-auto-grow-mount-point"
  );
  ReactDOM.render(<ExternalPurchaseAutoGrow />, mountPoint);
});
